$(document).ready(() => {
  $(".js-open-cart").click(function (e) {
    on();
    $(".cart-wrapper").addClass("active");
    e.preventDefault();

    async function getLocation() {
      let url =
        "https://" +
        window.location.hostname +
        "/browsing_context_suggestions.json";
      let obj = await (await fetch(url)).json();
      let country = obj.detected_values.country.handle;
      let btnContainer = document.getElementById("btn-container");
      let beautycircleDetail = document.getElementById("beautycircle-detail");

      if (country === "NZ" && btnContainer.childNodes.length === 1) {
        let btn = document.createElement("button");
        btn.addEventListener("click", function (event) {
          CartJS.addItem(39601154949281);
        });
        btn.className = "nz-shipping-addtocart";
        btn.innerHTML = "Add to Cart";
        btnContainer.appendChild(btn);

        let detail = document.createElement("div");
        detail.innerHTML = "- free return shipping label for NZ.";
        beautycircleDetail.appendChild(detail);
      }

      if (country === "AU" && btnContainer.childNodes.length === 1) {
        let btn = document.createElement("button");
        btn.addEventListener("click", function (event) {
          CartJS.addItem(40907613798561);
        });
        btn.innerHTML = "Add to Cart";
        btnContainer.appendChild(btn);

        let detail = document.createElement("div");
        detail.innerHTML = "- free return shipping label for AU.";
        beautycircleDetail.appendChild(detail);
      }
    }

    getLocation();
  });

  $(".js-close-cart").click(function (e) {
    off();
    $(".cart-wrapper").removeClass("active");
    e.preventDefault();
  });

  /* Open Device Menu */
  var mobileMenuTl = gsap.timeline({
    paused: true,

    onStart: function () {
      $(".mobile-menu").addClass("active");
      $("body").addClass("menu-open");
    },

    onReverseComplete: function () {
      $(".mobile-menu").removeClass("active");
      $("body").removeClass("menu-open");
    },
  });

  mobileMenuTl.fromTo(
    ".mobile-menu",
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
    }
  );

  mobileMenuTl.fromTo(
    ".mobile-menu .nav-links > a",
    {
      autoAlpha: 0,
      x: 15,
    },
    {
      autoAlpha: 1,
      x: 0,
      duration: 0.3,
      stagger: 0.1,
    }
  );

  $(".mobile-menu-button").click(function (e) {
    e.preventDefault();
    mobileMenuTl.play();
  });

  $(".close-mobile-menu").click(function (e) {
    e.preventDefault();
    $("body").removeClass("mobile-menu-search-active search--show");
    $(".search-results").fadeOut();
    if (window.clearAllSearchInputs) {
      window.clearAllSearchInputs();
    }
    mobileMenuTl.reverse();
  });

  $("#select-option1").change(() => {
    $(".js-variant-id").val($("#select-option1").val());
    $("button#add-to-cart-button").prop("disabled", false);
  });

  /* Show Beauty Circle label on hover (Cart) */
  $(".detail").hover(
    function () {
      $(".beauty-circle-label-wrapper").show();
    },
    function () {
      $(".beauty-circle-label-wrapper").hide();
    }
  );

  function on() {
    document.getElementById("overlay").style.display = "block";
    document.body.style.overflowY = "hidden";
  }
  function off() {
    document.getElementById("overlay").style.display = "none";
    document.body.style.overflowY = "auto";
  }

  var current = location.pathname;
  var root = "/";
  if (
    "Shopify" in window &&
    "routes" in window.Shopify &&
    "root" in window.Shopify.routes
  ) {
    root = window.Shopify.routes.root;
    if (root !== "/") {
      root = root.replace(/\/$/, "");
    }
  }

  if (current !== root && current !== root + "#" && current !== root + "/!") {
    $("nav li a").each(function () {
      var $this = $(this);
      var href = $this.attr("href");

      if (href && href.indexOf("/blogs/skin-academy") !== -1) {
        return;
      }

      if (href && href.indexOf(current) !== -1) {
        $this.addClass("active");
      }
      if (current === root + "pages/our-story") {
        $('a.nav-link[href="/pages/about"]').addClass("active");
      }
      if (current === root + "collections/all") {
        $('a.nav-link[href="' + root + 'collections/all"]').addClass("active");
      }
    });

    var currentFullUrl = current + window.location.search;

    $("a[href*='/blogs/skin-academy']").each(function () {
      var $this = $(this);
      var href = $this.attr("href");

      $this.removeClass("active");

      // Check if we're on any skin-academy page and this is the main skin academy link
      if (
        current === "/blogs/skin-academy" &&
        (href === "/blogs/skin-academy" || href === "#")
      ) {
        $this.addClass("active");
      }
      // Check for exact match (for subpages or specific links)
      else if (href === currentFullUrl) {
        $this.addClass("active");
      }
    });
  }

  // if (current !== root && current !== root + "#" && current !== root + "/!") {
  //   $("nav li a").each(function () {
  //     var $this = $(this);
  //     // if the current path is like this link, make it active
  //     if ($this.attr("href").indexOf(current) !== -1) {
  //       // $this.css('text-decoration', 'underline');
  //       $this.addClass("active");
  //     }
  //     if (current === root + "pages/our-story") {
  //       // $('a.nav-link[href="/pages/about"]').css('text-decoration', 'underline');
  //       $('a.nav-link[href="/pages/about"]').addClass("active");
  //     }
  //     if (current === root + "collections/all") {
  //       // $('a.nav-link[href="/pages/about"]').css('text-decoration', 'underline');
  //       $('a.nav-link[href="' + root + 'collections/all"]').addClass("active");
  //     }
  //   });
  // }

  if (
    navigator.userAgent.indexOf("Safari") != -1 &&
    navigator.userAgent.indexOf("Chrome") == -1
  ) {
    jQuery(".cart-footer .gradient").each(function () {
      jQuery(this).attr("id", "safari");
    });
  }

  $(".search-results").hide();

  var searchDebounceTimer = null;
  var SEARCH_DEBOUNCE_MS = window.SEARCH_DEBOUNCE_MS || 300;

  function getSearchResultsRoot(searchInput) {
    if (searchInput && searchInput.closest(".mobile-menu")) {
      return document.querySelector(".mobile-menu .search-results--mobile");
    }
    return document.querySelector(".search .search-results--desktop");
  }

  function fetchSearchResults(keyWord, resultsRoot) {
    if (!resultsRoot) return;
    var $root = $(resultsRoot);

    $.ajax({
      url: `/search?q=${keyWord}*&type=product`,
      type: "GET",
      dataType: "html",
      success: function (data) {
        var products = $("<div />")
          .append(data)
          .find("ul.page-width.list-view-items .product-grid > div");

        var newProducts = [];
        for (var i = 0; i < products.length; i++) {
          const href = $(products[i])
            .find("a.product-item__link")
            .attr("href");
          if (
            href &&
            href.indexOf("emma-lewisham-beauty-circle-shipping-label") === -1
          ) {
            newProducts.push(products[i]);
          }
        }

        var totalResults = newProducts.length;
        var newHtml = "";
        var loop = parseInt(totalResults) < 3 ? parseInt(totalResults) : 3;
        if (products.length != 0) {
          for (var i = 0; i <= loop - 1; i++) {
            newHtml = newHtml + newProducts[i].outerHTML;
          }
          $root.find(".search-results__products .product-grid").html(newHtml);
          $root
            .find(".search-results__products .search-results__heading h2")
            .html(totalResults + " Results");
        } else {
          var productGrid = resultsRoot.querySelector(
            ".search-results__products .product-grid"
          );
          if (productGrid) productGrid.innerHTML = "";
          $root
            .find(".search-results__products .search-results__heading h2")
            .html(totalResults + " Results");
        }
      },
    });

    $.ajax({
      url: `/search?q=${keyWord}*&type=article`,
      type: "GET",
      dataType: "html",
      success: function (data) {
        var href = $("<div />")
          .append(data)
          .find("ul.page-width.list-view-items a.journal-item");
        var products = $("<div />")
          .append(data)
          .find("ul.page-width.list-view-items .journal-item .bottom");
        var totalResults = $("<div />")
          .append(data)
          .find("span#results-total")
          .html();
        var newHtml = "";
        var loop = parseInt(totalResults) < 3 ? parseInt(totalResults) : 3;
        if (products.length != 0) {
          for (var i = 0; i <= loop - 1; i++) {
            newHtml =
              newHtml +
              `<li>
    <a href="${$(href[i]).attr("href")}">
      ${$(products[i]).find(".title").html()}
      <span>
      ${$(products[i]).find(".date").html()}
      </span>
    </a>
  </li>`;
          }
          $root.find("ul.search-articles__list").html(newHtml);
          $root
            .find(".search-results__articles .search-results__heading h2")
            .html(totalResults + " Results");
        } else {
          var articlesList = resultsRoot.querySelector("ul.search-articles__list");
          if (articlesList) articlesList.innerHTML = "";
          $root
            .find(".search-results__articles .search-results__heading h2")
            .html(totalResults + " Results");
        }
      },
    });
  }

  function handleSearchInput(searchObj) {
    var keyWord = searchObj.value;
    var isMobileMenuSearch =
      window.innerWidth <= 960 && searchObj.closest(".mobile-menu");
    var resultsRoot = getSearchResultsRoot(searchObj);

    if (!resultsRoot) return;

    resultsRoot.querySelector(
      ".search-results__products .search-results__all"
    ).href = `/search?q=${keyWord}*&type=product`;
    resultsRoot.querySelector(
      ".search-results__articles .search-results__all"
    ).href = `/search?q=${keyWord}*&type=article`;

    clearTimeout(searchDebounceTimer);

    if (keyWord.trim() == "") {
      $(resultsRoot).fadeOut();
      if (isMobileMenuSearch) {
        document.body.classList.remove("mobile-menu-search-active");
      }
      return;
    }

    if (isMobileMenuSearch) {
      document.body.classList.remove("search--show");
      $(".search .search-results--desktop").hide();
      document.body.classList.add("mobile-menu-search-active");
      $(resultsRoot).fadeIn();
    } else {
      document.body.classList.remove("mobile-menu-search-active");
      $(".mobile-menu .search-results--mobile").hide();
      $(resultsRoot).fadeIn();
    }

    searchDebounceTimer = setTimeout(function () {
      fetchSearchResults(keyWord, resultsRoot);
    }, SEARCH_DEBOUNCE_MS);
  }

  var searchInputs = document.querySelectorAll(".search__input");
  searchInputs.forEach(function (searchObj) {
    searchObj.oninput = function () {
      handleSearchInput(searchObj);
    };
  });
});
